export interface StepPosition {
    label: string;
    widthPercent: number;
}

export const toStepPosition = (currentStepIndex: number, totalSteps: number): StepPosition | null => {
    if (totalSteps <= 0 || currentStepIndex < 0 || currentStepIndex >= totalSteps) {
        return null;
    }
    const stepNumber = currentStepIndex + 1;
    return {
        label: `Step ${stepNumber} of ${totalSteps}`,
        widthPercent: (stepNumber / totalSteps) * 100,
    };
};
